/*
 * Widerruf-Formular – zweistufige Bestätigung (Progressive Enhancement).
 *
 * Ohne JS funktioniert das Formular bereits als bewusster Schritt
 * (Pflicht-Checkbox + Absenden-Button). Mit JS wird zwischen Absenden und
 * tatsächlichem Versand ein nativer <dialog> mit Datenübersicht eingeschoben,
 * den die Person aktiv bestätigen muss.
 */
class WiderrufForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('#WiderrufForm');
    this.dialog = this.querySelector('[data-widerruf-dialog]');
    this.summary = this.querySelector('[data-widerruf-summary]');
    this.confirmed = false;

    // Ohne unterstützten <dialog> oder ohne Formular: native Abgabe genügt.
    if (!this.form || !this.dialog || typeof this.dialog.showModal !== 'function') return;

    this.form.addEventListener('submit', this.#handleSubmit);
    this.dialog.addEventListener('close', this.#handleClose);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.#handleSubmit);
    this.dialog?.removeEventListener('close', this.#handleClose);
  }

  #handleSubmit = (event) => {
    if (this.confirmed) return; // zweiter Durchlauf -> echter Versand
    if (!this.form.reportValidity()) return; // Pflichtfelder zuerst prüfen

    event.preventDefault();
    this.#renderSummary();
    this.dialog.showModal();
  };

  #handleClose = () => {
    if (this.dialog.returnValue !== 'confirm') return;
    this.confirmed = true;
    this.form.requestSubmit();
  };

  #renderSummary() {
    const list = document.createElement('dl');

    for (const field of this.form.querySelectorAll('[data-summary-label]')) {
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) continue;

      const value = field.type === 'checkbox' ? 'Ja' : field.value.trim();
      if (!value) continue;

      const term = document.createElement('dt');
      term.textContent = field.dataset.summaryLabel;
      const description = document.createElement('dd');
      description.textContent = value;
      list.append(term, description);
    }

    this.summary.replaceChildren(list);
  }
}

customElements.define('widerruf-form', WiderrufForm);
